import { Inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
	providedIn: 'root',
})
export class SeoService {
	constructor(
		@Inject(DOCUMENT) private readonly doc: Document,
		private readonly _meta: Meta,
		private readonly title: Title,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	public addTags(res: any) {
		this.updateTag(res.description, 'description');
		this.updateTag(res.metaTitle, 'title');
		this.updateTag(res.keywords, 'keywords');
		// this.updateTag(res.robots, 'robots');
		// this.updateTagOg(res.ogUrl, 'og:url');
		this.updateTagOg(res.ogDescription, 'og:ogDescription');
		this.updateTagOg(res.ogTitle, 'og:ogTitle');
		this.title.setTitle(res.title);
		this.createLinkForCanonicalURL(res.linkCanonical);
	}

	public updateTag(tag: string, name: string) {
		this._meta.updateTag({ name: name, content: tag });
	}

	public updateTagOg(tag: string, name: string) {
		this._meta.updateTag({ property: name, content: tag });
	}

	public createLinkForCanonicalURL(canonical: string) {
		if (isPlatformBrowser(this.platformId)) {
			let baseUrl = window.location.origin + window.location.pathname;
			let elementLink: any = this.doc?.querySelector(`link[rel='canonical']`);
			let link: HTMLLinkElement = elementLink;
			if (elementLink == null) {
				link = this.doc?.createElement('link');
				link.setAttribute('rel', 'canonical');
				this.doc?.head.appendChild(link);
			}
			link.setAttribute('href', baseUrl);
		}
	}
}
